import { Stack } from 'expo-router';
import { useEffect, useState } from 'react';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import { CONTENT_LOADING_DELAY_MS } from '@/hooks/useDelayedLoading';
import signOut from '@/utils/signOut';
import Box from '../UI/Box';
import Spinner from './Spinner';

const FADEIN_TEXT_DELAY = 5000;
const CHANGE_TEXT_DELAY = 15000;
const SIGNOUT_DELAY = 20000;

export default function Loading() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      signOut();
    }, SIGNOUT_DELAY);

    return () => clearTimeout(timeout);
  }, []);
  const [loadingText, setLoadingText] = useState(
    'This is taking a little longer than usual. Please wait.',
  );

  const spinnerOpacity = useSharedValue(0);
  const loadingTextOpacity = useSharedValue(0);

  const spinnerAnimatedStyle = useAnimatedStyle(() => ({
    opacity: spinnerOpacity.value,
  }));

  const loadingTextAnimatedStyle = useAnimatedStyle(() => ({
    opacity: loadingTextOpacity.value,
  }));

  useEffect(() => {
    const showSpinner = setTimeout(() => {
      spinnerOpacity.value = withTiming(1);
    }, CONTENT_LOADING_DELAY_MS);

    const showLoadingText = setTimeout(() => {
      loadingTextOpacity.value = withTiming(1);
    }, FADEIN_TEXT_DELAY);

    const changeLoadingText = setTimeout(() => {
      setLoadingText('Signing out. Please try signing in again.');
    }, CHANGE_TEXT_DELAY);

    return () => {
      clearTimeout(showSpinner);
      clearTimeout(showLoadingText);
      clearTimeout(changeLoadingText);
    };
  }, [loadingTextOpacity, spinnerOpacity]);

  return (
    <Box
      space="xl"
      justifyContent="center"
      alignItems="center"
      flex
      style={style.container}
    >
      <Stack.Screen options={{ headerTitle: '' }} />
      <Animated.View style={spinnerAnimatedStyle}>
        <Spinner size="lg" />
      </Animated.View>
      <Animated.View style={loadingTextAnimatedStyle}>
        <Text style={style.text} size="xl">
          {loadingText}
        </Text>
      </Animated.View>
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    backgroundColor: theme.colors.background,
  },
  text: {
    color: theme.colors.typography,
    textAlign: 'center',
  },
}));
